import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VirtualScrollModule } from 'angular2-virtual-scroll';
import { FeaturesModule } from '../features/features.module';
import { SharedModule } from '../shared/shared.module';
import { BasicFeedListItemComponent } from './components/basic-feed-list-item/basic-feed-list-item.component';
import { PlaceholderFeedComponent } from './components/placeholder-feed/placeholder-feed.component';
import { FeedComponent } from './feed.component';

const internalComponents = [PlaceholderFeedComponent];

const exportableComponents = [FeedComponent, BasicFeedListItemComponent];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FeaturesModule,
    VirtualScrollModule,
  ],
  declarations: [...internalComponents, ...exportableComponents],
  exports: [...exportableComponents],
})
export class FeedModule {}
